import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store';

const routes = [
    {
        path: '/crypto',
        name: 'crypto',
        component: () => import('../views/auth/CryptoView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/auth/LoginView.vue'),
        meta: { guestOnly: true }
    },
    {
        path: '/',
        name: 'home',
        component: () => import('../views/HomeView.vue'),
        meta: {
            breadcrumb: [
                { title: 'Dashboard Principal', text: "Inicio", path: '/', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/transferencias',
        name: 'transferencias',
        component: () => import('../views/Transferencias/TransferenciasView.vue'),
        meta: {
            breadcrumb: [
                { title: 'Dashboard Principal', text: "Inicio", path: '/', disabled: false },
                { title: 'Transferencias', text: "Transferencias", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/movimientos',
        name: 'movimientos',
        component: () => import('../views/Movimientos/MovimientosView.vue'),
        meta: {
            breadcrumb: [
                { title: 'Dashboard Principal', text: "Inicio", path: '/', disabled: false },
                { title: 'Movimientos', text: "Movimientos", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/tarjetas',
        name: 'tarjetas',
        component: () => import('../views/Tarjetas/TarjetasView.vue'),
        meta: {
            breadcrumb: [
                { title: 'Dashboard Principal', text: "Inicio", path: '/', disabled: false },
                { title: 'Tarjetas', text: "Tarjetas", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/seguridad',
        name: 'seguridad',
        component: () => import('../views/Configuracion/SeguridadView.vue'),
        meta: {
            breadcrumb: [
                { title: 'Dashboard Principal', text: "Inicio", path: '/', disabled: false },
                { title: 'Seguridad', text: "Seguridad", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/perfil',
        name: 'perfil',
        component: () => import('../views/Configuracion/PerfilView.vue'),
        meta: {
            breadcrumb: [
                { title: 'Dashboard Principal', text: "Inicio", path: '/', disabled: false },
                { title: 'Perfil', text: "Perfil", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/cuentas',
        name: 'cuentas',
        component: () => import('../views/Cuentas/CuentasView.vue'),
        meta: {
            breadcrumb: [
                { title: 'Dashboard Principal', text: "Inicio", path: '/', disabled: false },
                { title: 'Mis Cuentas', text: "Cuentas", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },

    {
        path: '/cuenta/detalleCuentaMoral/:id',
        name: 'detalleCuentaMoral',
        component: () => import('../views/Persona/PersonaMoralView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { text: "Cuentas", path: '/cuentas', disabled: true },
                { title: 'Detalle Cuenta Persona Moral', text: "Persona Moral", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/cuenta//detalleCuentaFisicaAE/:id',
        name: 'detalleCuentaFisicaAE',
        component: () => import('../views/Persona/PersonaMoralView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { text: "Cuentas", path: '/cuentas', disabled: true },
                { title: 'Detalle Cuenta Persona Actividad Empresarial', text: "Actividad Empresarial", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/cuenta/detalleCuentaFisica/:id',
        name: 'detalleCuentaFisica',
        component: () => import('../views/Persona/PersonaFisicaView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { text: "Cuentas", path: '/cuentas', disabled: true },
                { title: 'Detalle Cuenta Persona Física', text: "Persona Física", path: '#', disabled: true },
                
            ],
            requiresAuth: true
        }
    },
    /*
    {
        path: '/alcancia',
        name: 'alcancia',
        component: () => import('../views/Alcancia/AlcanciaView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { title: 'Alcancía', text: "Alcancía", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },

    {
        path: '/alcancia/agregar',
        name: 'AgregarAlcancia',
        component: () => import('../views/Alcancia/AgregarAlcancia.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { text: "Alcancía", path: '/alcancia', disabled: true },
                { title: 'Agregar alcancía', text: "Agregar alcancía", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/alcancia/detalle/:id',
        name: 'detalleAlcancia',
        component: () => import('../views/Alcancia/DetalleAlcancia.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { text: "Alcancía", path: '/alcancia', disabled: true },
                { title: 'Detalle alcancía', text: "Detalle alcancía", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/prestamo/solicitar',
        name: 'solicitarPrestamo',
        component: () => import('../views/Prestamo/SolicitarPrestamoView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { title: 'Préstamo', text: "Préstamo", path: '/prestamo', disabled: true },
                { title: 'Solicitar préstamo', text: "Solicitar préstamo", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/prestamo',
        name: 'prestamo',
        component: () => import('../views/Prestamo/PrestamoView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { title: 'Préstamo', text: "Préstamo", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    */
    /*
    {
        path: '/pagoServicios',
        name: 'pagoServicios',
        component: () => import('../views/PagoServicios/PagoServiciosView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { title: 'Pago de servicios', text: "Pago de servicios", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    {
        path: '/pagoServicios/:id',
        name: 'pagoServicio',
        component: () => import('../views/PagoServicios/PagoServiciosView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { title: 'Pago de servicios', text: "Pago de servicios", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    */
    /*
    {
        path: '/preguntas',
        name: 'preguntas',
        component: () => import('../views/Preguntas/PreguntasView.vue'),
        meta: {
            breadcrumb: [
                { text: "Inicio", path: '/', disabled: false },
                { title: 'Preguntas', text: "Preguntas", path: '#', disabled: true },
            ],
            requiresAuth: true
        }
    },
    */
    { 
        path: '/:pathMatch(.*)*', 
        name: 'NotFound', 
        component: () => import('../views/NotFound.vue') 
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})
// Navigation guard to check for auth
router.beforeEach(async (to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated;

    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        next('/login');
        return
    }
    if (to.matched.some(record => record.meta.guestOnly) && isAuthenticated) {
        next('/');
        return;
    }
    next();
});
export default router
